import { MutationFunction, QueryKey, useMutation, useQueryClient } from '@tanstack/react-query'
import { fromAxiosError, useGlobalError } from '../context/GlobalError'

export function useInvalidatingMutation<TData, TVariables>(
  mutationFn: MutationFunction<TData, TVariables>,
  queriesToInvalidate: QueryKey[]
) {
  const { addError } = useGlobalError()
  const queryClient = useQueryClient()
  return useMutation(mutationFn, {
    onMutate: () => queriesToInvalidate.forEach(q => queryClient.cancelQueries(q)),
    onError: (err: any) => {
      const e = fromAxiosError(err)
      addError(e?.message, e?.status)
    },
    onSettled: () => queriesToInvalidate.forEach(q => queryClient.invalidateQueries(q)),
  })
}
